<template>
    <div class="tree_item col-md-12">
        <div class="row">
            <div class="name col-md-6">
                <div class="row">
                    <div class="button_expand col-md-1">
                        <i :class="[opened ? 'el-icon-arrow-down' : 'el-icon-arrow-right']" @click="expand(data)"></i>
                    </div>
                    <div class="name col-md-11" :class="{'not_empty': data.products.length || data.children}">{{data.name}}</div>
                </div>
            </div>
            <div class="r_side col-md-6">
                <div class="row">
                    <div class="unit col-md-6"></div>
                    <div class="actions col-md-6"></div>
                </div>
            </div>
        </div>
        <div class="good_item row" v-show="opened"
             v-if="data.products.length"
             v-for="(goodsItem, $index) in data.products">
            <div class="name col-md-6">
                <div class="row">
                    <div class="button_expand col-md-2"></div>
                    <div class="name col-md-10">
                        <router-link class="link"
                                     :to="{name: 'Goods.edit', params:{id: goodsItem.id}}">
                            {{goodsItem.name}}
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="r_side col-md-6">
                <div class="row">
                    <div class="unit" :class="'col-md-'+(12/places.length)"
                                        v-for="storage in goodsItem.storages">
                        <span class="from">{{storage.toStorage}}</span>
                        <strong>|</strong>
                        <span class="to">{{storage.fromStorage}}</span>
                    </div>
                </div>
            </div>
        </div>
        <SGRTree v-if="data.children"
                 v-for="child in data.children"
                 :data="child"
                 v-show="opened">
        </SGRTree>
    </div>
</template>

<script>
    import { getCategories } from "../../api";
    import { sortStorages} from "../../services/treeServices";
    import {findIndex} from "lodash"

    export default {
        name: 'SGRTree',
        data(){
            return{
                opened: false
            }
        },
        created(){
        },
        props: {
            data:{
                type: Object
            },
            places:{
                type: Array
            }
        },
        updated(){
            if(this.places){
                // sortStorages(this.data.products,this.places);
            }
        },
        methods:{
            expand(data){
                if(data.children || data.products.length){
                    this.opened = !this.opened;
                }
                this.$forceUpdate();
            },
            hover(event){
            },
            removeNode(id,index,array){
                deleteGoodsItem(id).then(response=>{
                    array.splice(index,1);
                });
            }
        }
    }
</script>

<style>
    .actions,
    .button_expand{
        cursor: pointer;
    }
    .tree_item{
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .good_item:hover{
        background: rgba(135,206,250,.4);
    }
    .not_empty{
        font-weight: bolder;
    }
    .link:hover{
        text-decoration: none;
        color: black;
    }
    .remove:hover{
        color: red;
    }

    .from{
        color: green;
    }
    .to{
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/modules/productsStorage/components/trees/storage_and_goods_report_tree.vue